var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 249,
    viewBox: "0 0 412 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_637_883)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 392,
    height: 229,
    rx: 20,
    fill: "url(#pattern0)",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M251 125.5L176.75 168.368L176.75 82.6317L251 125.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_637_883",
    x: 0,
    y: 0,
    width: 412,
    height: 249,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_637_883"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_637_883",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_637_883",
    transform: "matrix(0.00435958 0 0 0.00746269 -0.01879 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_637_883",
    width: 238,
    height: 134,
    xlinkHref: "data:image/jpeg;base64,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"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo1);
export default __webpack_public_path__ + "static/media/video1.9cc5fe947b80d17b35774f14a897bf63.svg";
export { ForwardRef as ReactComponent };